var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-not-selected tag-list"},_vm._l((_vm.tagList),function(item,index){return _c('a-tag',{key:index,staticClass:"tag",on:{"click":function($event){return _vm.handleSelect(item.name)}}},[_vm._v(_vm._s(item.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }